import { render, staticRenderFns } from "./g-time-select-item.vue?vue&type=template&id=128af8e6&"
import script from "./g-time-select-item.vue?vue&type=script&lang=js&"
export * from "./g-time-select-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports